import { Injectable } from '@angular/core';
import { Camera, CameraDirection, CameraResultType, CameraSource } from '@capacitor/camera';
import { Platform } from '@ionic/angular';
import { ToastService } from './toast.service';

export interface ILocalFile {
  name?: string;
  data: string;
}

const DEFAULT_PICTURE_QUALITY = 80;

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor(
    private platform: Platform,
    private toastService: ToastService,
  ) {}

  async selectImage(quality = DEFAULT_PICTURE_QUALITY) {
    try {
      const image = await Camera.getPhoto({
        quality,
        allowEditing: false,
        source: this.platform.is('hybrid') ? CameraSource.Prompt : CameraSource.Photos,
        resultType: CameraResultType.Base64,
        direction: CameraDirection.Rear,
      });

      return `data:image/${image.format};base64,${image.base64String}`;
    } catch (error: any) {
      if (error?.message.includes('denied')) {
        this.toastService.showToast({
          summary: 'Gagal mengambil gambar',
          detail: 'Anda tidak mengizinkan aplikasi mengakses kamera',
          severity: 'error',
        });
      }
      return null;
    }
  }

  async convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.readAsDataURL(file);
    });
  }

  // async saveImage(photo: Photo) {
  //   const base64Data = await this.readAsBase64(photo)

  //   const fileName = new Date().getTime() + '.jpeg'
  //   const savedFile = await Filesystem.writeFile({
  //     directory: Directory.Data,
  //     path: `${IMAGE_DIR}/${fileName}`,
  //     data: base64Data,
  //   })
  // }

  // async readAsBase64(photo: Photo) {
  //   if (this.platform.is('hybrid')) {
  //     const file = await Filesystem.readFile({
  //       path: photo.path!,
  //     })
  //     return `data:image/${photo.format};base64,${file.data}`
  //   }

  //   const response = await fetch(photo.webPath!)
  //   const blob = await response.blob()

  //   return (await this.convertBlobToBase64(blob)) as string
  // }

  // convertBlobToBase64(blob: Blob) {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader()
  //     reader.onerror = reject
  //     reader.onload = () => {
  //       resolve(reader.result)
  //     }
  //     reader.readAsDataURL(blob)
  //   })
  // }
}
